<div class="p-4">
  <form [formGroup]="form" (ngSubmit)="submit()" class="mat-typography" style="max-width: 600px; margin: auto;">

    <div *ngFor="let key of keys(form.value)" [formGroupName]="key" style="margin-bottom: 24px;">

      <!-- Campos escalares -->
      <ng-container *ngIf="form.get(key)?.get('value')">

        <!-- Booleanos (mat-checkbox) -->
        <mat-checkbox *ngIf="isBoolean(form.get(key)?.get('value')?.value)" [formControlName]="'value'">
          {{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}
        </mat-checkbox>

        <!-- DateTime (Taiga UI fuera de mat-form-field) -->
        <ng-container *ngIf="isDateTimeField(key)">
          <label class="block mb-1">{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}</label>
          <tui-input-date-time [formControlName]="'value'"
                               format="dd.MM.yyyy HH:mm">
          </tui-input-date-time>
        </ng-container>

        <!-- Otros valores escalares (mat-form-field) -->
        <!-- Select para "unit" -->
        <mat-form-field appearance="fill" style="width: 100%;" *ngIf="key === 'unit'">
          <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}</mat-label>
          <mat-select [formControlName]="'value'">
            <mat-option *ngFor="let option of unitOptions" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get(key)?.get('value')?.invalid && (form.get(key)?.get('value')?.touched || form.get(key)?.get('value')?.dirty)">
            {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Select para "appliesTo" (solo para partners) -->
        <mat-form-field appearance="fill" style="width: 100%;" *ngIf="key === 'appliesTo' && form_structure === 'partner'">
          <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}</mat-label>
          <mat-select [formControlName]="'value'">
            <mat-option *ngFor="let option of appliesToOptions" [value]="option.key">{{ option.value }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get(key)?.get('value')?.invalid && (form.get(key)?.get('value')?.touched || form.get(key)?.get('value')?.dirty)">
            {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Select para "unit" (solo para partners) -->
        <mat-form-field appearance="fill" style="width: 100%;" *ngIf="key === 'unit' && form_structure === 'partner'">
          <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}</mat-label>
          <mat-select [formControlName]="'value'">
            <mat-option *ngFor="let option of unitOptions" [value]="option.key">{{ option.value }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get(key)?.get('value')?.invalid && (form.get(key)?.get('value')?.touched || form.get(key)?.get('value')?.dirty)">
            {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- Input texto para los demás keys que no son booleanos, fechas, "unit" o "appliesTo" -->
        <mat-form-field appearance="fill" style="width: 100%;"
                        *ngIf="key !== 'unit' && key !== 'appliesTo' && !isBoolean(form.get(key)?.get('value')?.value) && !isDateTimeField(key) && (key !== 'id' || form_structure !== 'partner')">
          <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}}</mat-label>
          <input matInput [formControlName]="'value'" type="text" [readonly]="(key == 'id' && isNotEmpty(item)) || (key == 'partnerCode' && isPartnerCodeFromUrl())" />
          <mat-error *ngIf="form.get(key)?.get('value')?.invalid && (form.get(key)?.get('value')?.touched || form.get(key)?.get('value')?.dirty)">
            {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>


      </ng-container>

      <!-- Listas (FormArray) -->
      <div *ngIf="form.get(key)?.get('list') as list" formArrayName="list" style="border: 1px solid #ccc; padding: 10px; border-radius: 8px;">
        <h3>{{'LISTS.'+ (form_structure | uppercase) +'.'+(key | uppercase) | translate}} {{ 'CONDITIONS.FORM.LIST' | translate }}</h3>

        <div *ngFor="let item of getFormArray(list).controls; let i = index" [formGroupName]="i" style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #ddd;">
          <div *ngFor="let subKey of getOrderedFields(item.value)">
            <!-- Select para "unit" dentro de revenue (solo para partners) -->
            <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 8px;" *ngIf="subKey === 'unit' && form_structure === 'partner'">
              <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(subKey | uppercase) | translate}}</mat-label>
              <mat-select [formControlName]="subKey">
                <mat-option *ngFor="let option of unitOptions" [value]="option.key">{{ option.value }}</mat-option>
              </mat-select>
              <mat-error *ngIf="item.get(subKey)?.invalid && (item.get(subKey)?.touched || item.get(subKey)?.dirty)">
                {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>

            <!-- Input para los demás campos dentro de revenue -->
            <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 8px;" *ngIf="subKey !== 'unit' || form_structure !== 'partner'">
              <mat-label>{{'LISTS.'+ (form_structure | uppercase) +'.'+(subKey | uppercase) | translate}}</mat-label>
              <input matInput [formControlName]="subKey" />
              <mat-error *ngIf="item.get(subKey)?.invalid && (item.get(subKey)?.touched || item.get(subKey)?.dirty)">
                {{ 'CONDITIONS.FORM.REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <app-button color="secondary" type="button" (click)="removeItem(key, i)">
            <mat-icon>remove_circle</mat-icon>
          </app-button>
        </div>

        <app-button class="flex-end" color="primary" type="button" (click)="addItem(key)">
          <div class="items-center flex gap-2"><mat-icon>add_circle</mat-icon><span>{{ 'CONDITIONS.FORM.ADD' | translate }}</span></div>
        </app-button>
      </div>

    </div>

    <div class="flex justify-between">
      <app-button color="secondary" typeof="button" (click)="toggleBlock($event)">{{ 'CONDITIONS.FORM.CANCEL' | translate }}</app-button>
      <app-button color="primary" type="submit" [disabled]="form.invalid">{{ 'CONDITIONS.FORM.SAVE' | translate }}</app-button>
    </div>
  </form>

</div>
